import {
  Box,
  Button,
  Checkbox,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  ImageList,
  ImageListItem,
  Typography,
} from '@mui/material';

import PropTypes from 'prop-types';
import React, { useState } from 'react';
import { doc, updateDoc } from 'firebase/firestore';
import { db } from '../../../firebase/config';
import '../../StaffGallery/StaffGallery.css';
import Slideshow from '../../../Components/Slideshow/Slideshow';
const CalendarImages = ({
  facilityId,
  calendarImages,
  setCalendarImages,
  setIsLoading,
  getCalendarImages,
}) => {
  const [openSelect, setOpenSelect] = useState(false);

  const handlClosechosedImage = () => {
    setOpenSelect(false);
    getCalendarImages();
  };

  const handlSaveSelectedImages = async () => {
    setIsLoading(true);

    try {
      const updatePromises = calendarImages.map(async (img) => {
        const docRef = doc(db, 'images', img.id);
        await updateDoc(docRef, {
          selected: img.selected,
        });
      });

      // Wait for all updates to finish
      await Promise.all(updatePromises);
    } catch (error) {
      console.error('Error updating images:', error);
    } finally {
      setIsLoading(false);
      setOpenSelect(false);
    }
  };

  const handleChooseImage = (index) => {
    // handle multi select image
    setCalendarImages(
      calendarImages.map((img, idx) =>
        idx === index ? { ...img, selected: !img.selected } : img,
      ),
    );
  };

  return (
    <>
      <Box
        sx={{
          width: '100%',
          display: 'flex',
          flexDirection: 'column',
        }}
      >
        <Typography variant="h5" sx={{ fontWeight: 'bold' }}>
          Slideshow:
        </Typography>

        <Box
          sx={{
            display: 'flex',
            width: 'auto',
            height: '100%',
            gap: 2,
            alignItems: 'start',
            paddingTop: '14px',
          }}
        >
          <Box
            sx={{
              display: 'flex',
              width: '30%',
              height: '100%',
              flexDirection: 'column',
              justifyContent: 'center',
              alignItems: 'center',
              gap: 2,
            }}
          >
            <Button
              variant="contained"
              sx={{
                borderRadius: 2,
                textTransform: 'none',
                fontWeight: 'bold',
                fontSize: 20,
                width: '100%',
              }}
              onClick={() => setOpenSelect(true)}
            >
              Choose Images
            </Button>
          </Box>
          {calendarImages.some((img) => img.selected) && (
            <Box
              sx={{
                flexDirection: 'column',
                gap: 1,
                height: '100%',
                width: '70%',
              }}
            >
              {calendarImages.filter((img) => img.selected).length > 0 && (
                <Slideshow
                  images={calendarImages
                    .filter((img) => img.selected)
                    .map((img) => ({
                      ...img,
                      originalWidth: 400,
                      originalHeight: 300,
                    }))}
                  facilityId={facilityId}
                />
              )}
            </Box>
          )}
        </Box>
        <Dialog open={openSelect} onClose={handlClosechosedImage}>
          <DialogTitle>Select Images</DialogTitle>
          <DialogContent>
            <Box
              sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}
            ></Box>
            <hr />
            <ImageList cols={3} variant="masonry" id="galleryContainer">
              {calendarImages &&
                Array.from(calendarImages).map((img, index) => (
                  <ImageListItem key={index}>
                    <img
                      src={img.imageUrl}
                      srcSet={img.imageUrl}
                      alt={img.residentId}
                      loading="lazy"
                      style={{
                        width: '100%',
                        height: '100%',
                        transition: 'opacity 0.4s ease',
                        opacity: img.selected ? 0.8 : 1,
                      }}
                    />
                    <Checkbox
                      checked={img.selected}
                      onChange={() => handleChooseImage(index)}
                    />
                  </ImageListItem>
                ))}
            </ImageList>
          </DialogContent>
          <DialogActions sx={{ justifyContent: 'center', mb: 2 }}>
            <Button onClick={handlClosechosedImage}>Cancel</Button>
            <Button
              onClick={handlSaveSelectedImages}
              variant="contained"
              color="primary"
            >
              Save
            </Button>
          </DialogActions>
        </Dialog>
      </Box>
    </>
  );
};

CalendarImages.propTypes = {
  facilityId: PropTypes.string,
  calendarImages: PropTypes.array,
  setCalendarImages: PropTypes.func,
  setIsLoading: PropTypes.func,
  getCalendarImages: PropTypes.func,
};
export default CalendarImages;
